import type { AnalyticsUserPropertiesType } from '../types';
import type { IAttribution } from './types';

export function attributionToAnalyticsProperties(
  attribution: IAttribution,
): AnalyticsUserPropertiesType {
  const entries: Array<[string, string | null]> = [
    ['utm_source', attribution.source],
    ['utm_medium', attribution.medium],
    ['utm_campaign', attribution.campaign],
    ['utm_term', attribution.term],
    ['utm_content', attribution.content],
    ['gclid', attribution.gclid],
    ['fbclid', attribution.fbclid],
    ['ttclid', attribution.ttclid],
    ['msclkid', attribution.msclkid],
    ['page_template', attribution.landingTemplate],
    ['page_phrase', attribution.landingPhrase],
    ['channel', attribution.channel],
  ];
  const properties: AnalyticsUserPropertiesType = {};
  for (const [key, value] of entries) {
    if (value) {
      properties[key] = value;
    }
  }
  return properties;
}
